import axios from "axios";

export default {
  http: axios.create({
    withCredentials: true,
    baseURL: process.env.VUE_APP_API_BASE_URL || "/",
  }),
  mb_base_url: process.env.VUE_APP_MEDIABRAINS_URL,
};
